import { createChannel } from "./createChannel";

const [
  websocketDisconnectionPublisher,
  websocketDisconnectionSubscriber,
] = createChannel<{}>({
  name: "websocket-disconnection",
  publisherOrigin: "*",
  subscriberOrigin: "*",
});

export { websocketDisconnectionPublisher, websocketDisconnectionSubscriber };
